export enum Industry {
  Restaurants = "restaurants",
  Cafes = "cafes",
  Retail = "retail",
  Bakeries = "bakeries",
}
